import *as React from 'react'

import {postier} from './Postier'
import {AppContext} from "../../../Context/AppContext"

import "./style.scss"
import { ReactElement, useContext, useState } from 'react'

export function ExpHours(): ReactElement {

    const {token,site,client,setLoading, setErrors} = useContext(AppContext)
    const [horaires, setHoraireData] = useState([])

    const setHoraires = (arg)=>{
        setLoading(false)
        setHoraireData(arg)
    }


    React.useEffect(() => {
        setLoading(true)

        if(site&&client){postier.getHoraires(token,client,site,setHoraires, setErrors)}
    }, [site,client])


    const days = horaires.map(day=>{
    
    const date = new Date(day.Date)
    const opening = new Date(day.Opening)
    const middayClose = new Date(day.MiddayClosing)
    const middayOpening = new Date(day.MidddayOpening)
    const closing = new Date(day.Closing)


    return <tr className="day" key={Math.random()}>
        <td className="hour">{date.toLocaleDateString()}</td>
        <td className="hour">{opening.toLocaleTimeString()}</td>
        <td className="hour">{middayClose.toLocaleTimeString()}</td>
        <td className="hour">{middayOpening.toLocaleTimeString()}</td>
        <td className="hour">{closing.toLocaleTimeString()}</td>
    </tr>})

    return (
        <table className="semaineExp">
            {/* <thead className="day headder" key={Math.random()}> */}
                <tr className="head">
                    <td className="hour head">date</td>
                    <td className="hour head">ouverture</td>
                    <td className="hour head">début pause</td>
                    <td className="hour head">fin pause</td>
                    <td className="hour head">fermeture</td>
                </tr>
                
            {/* </thead>
            <tbody> */}
                {days}
            {/* </tbody> */}
            
        </table>
    )
}
